<div *ngIf="compsTableData && compsTableData.title" class="table-title">
  <div
    style="
      border: #c5ccd6 1px solid;
      padding: 5px;
      font-size: 12px;
      border-bottom: none;
      font-weight: 700;
      font-size: 12px;
      color: black;
    "
    [ngClass]="{
      'fuzzy-title':
        fuzzySwitch &&
        compsTableData.columnData[displayColumns[displayColumns.length - 1]] &&
        compsTableData.columnData[displayColumns[displayColumns.length - 1]]
          .isFuzzy
    }"
  >
    {{ compsTableData.title }}
  </div>
</div>
<div
  class="comps-grid-container"
  [ngClass]="tableClassName"
  [ngStyle]="{ 'max-height.px': maxHeight }"
>
  <div *ngIf="!metaReady">
    <ul nz-menu>
      <li
        *ngFor="let dummySection of [0, 1, 2, 3, 4, 5]"
        style="padding: 0px 15px 0px 15px"
      >
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul>
  </div>
  <div
    style="visibility: hidden; position: fixed"
    [style.left]="contextMenuPosition.x"
    [style.top]="contextMenuPosition.y"
    [matMenuTriggerFor]="contextMenu"
  ></div>
  <mat-menu #contextMenu="matMenu" class="mat-menu-container">
    <ng-template matMenuContent let-item="item">
      <ng-container *ngIf="!contextMenuReady">
        <ul nz-menu style="width: 200px">
          <li
            *ngFor="let dummySection of [0, 1, 2, 3, 4, 5]"
            style="padding: 0px 15px 0px 15px"
          >
            <nz-skeleton
              [nzTitle]="true"
              [nzActive]="true"
              [nzParagraph]="false"
            ></nz-skeleton>
          </li>
        </ul>
      </ng-container>
      <div
        *ngIf="contextMenuReady"
        style="
          padding: 16px 0px 20px 16px;
          border-radius: 3px;
          width: 200px;
          border: solid 1px #36abad;
          font-size: 12px;
          line-height: 1.5;
          box-shadow:
            0 4px 4px 0 rgba(126, 126, 126, 0.16),
            0 0 2px 1px rgba(0, 0, 0, 0.12),
            0 4px 8px -4px rgba(0, 0, 0, 0.16);
          background-color: #ffffff;
        "
      >
        <div style="font-weight: bold; color: #222222">Shortcuts:</div>
        <div style="padding: 4px 0px 8px 12px; color: #1874ae">
          <div
            (click)="showFormulaBar()"
            class="context-item"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
          >
            Audit Formula
          </div>
        </div>
        <div
          *ngIf="
            item.showRevision ||
            item.showDistribution ||
            item.showSurprise ||
            (this.source.toLowerCase() !== 'consensus+' && item.showTrend)
          "
          style="font-weight: bold; color: #222222"
        >
          {{ item.row.ticker }} Charts
        </div>
        <div
          *ngIf="item.showChartOptions"
          style="padding: 4px 0px 8px 12px; color: #1874ae"
        >
          <div
            class="context-item"
            *ngIf="this.source.toLowerCase() !== 'consensus+' && item.showTrend"
            (click)="showChartPopup(item, 'trend')"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
          >
            Trend
          </div>
          <div
            class="context-item"
            *ngIf="item.showRevision"
            (click)="showChartPopup(item, 'revision')"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
          >
            Revision
          </div>
          <div
            class="context-item"
            *ngIf="item.showDistribution"
            (click)="showChartPopup(item, 'distribution')"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
          >
            Distribution
          </div>
          <div
            class="context-item"
            *ngIf="item.showSurprise"
            (click)="showChartPopup(item, 'surprise')"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
          >
            Surprise
          </div>
        </div>
        <div
          *ngIf="
            item.showPeerOptions &&
            (item.showPeerTrend || item.showPeerRevision)
          "
          style="font-weight: bold; color: #222222"
        >
          {{ item.row.ticker }} vs Peers Charts
        </div>
        <div
          *ngIf="item.showPeerOptions"
          style="padding: 4px 0px 0px 12px; color: #1874ae"
        >
          <div
            class="context-item"
            (click)="navigateToDedicatedPage(item, 'trend')"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
            *ngIf="item.showPeerTrend"
          >
            Trend
          </div>
          <div
            class="context-item"
            (click)="navigateToDedicatedPage(item, 'revision')"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
            *ngIf="item.showPeerRevision"
          >
            Revisions
          </div>
        </div>
      </div>
    </ng-template>
  </mat-menu>
  <table
    mat-table
    [dataSource]="compsTableData.rows"
    [ngStyle]="{ 'width.px': tableWidth }"
    *ngIf="metaReady"
    cellpadding="0"
    cellspacing="0"
  >
    <ng-container matColumnDef="ticker" sticky>
      <th mat-header-cell *matHeaderCellDef>
        {{ "Ticker (" + compsTableData.rows.length + ")" }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="ticker-cell"
        [ngClass]="{ 'ticker-cell-deletion': allowTickerDeletion }"
      >
        <a routerLink="{{ '/company/' + element.ticker }}" routerLinkActive>
          {{ element.ticker }}
        </a>
        <span
          *ngIf="allowTickerDeletion"
          class="del"
          (click)="deleteTicker(element)"
        >
          <va-icon
            size="small"
            name="close"
            style="color: red; float: right"
          ></va-icon>
        </span>
      </td>
      <td mat-footer-cell *matFooterCellDef class="summary-title-cell">
        <div>
          <div
            *ngIf="showAverage"
            class="data-summary-cell"
            [ngClass]="{ values: showValue && showYoy }"
            [ngStyle]="{
              height: showValue && showYoy ? '44px' : '22px',
              padding: showValue && showYoy ? '12px 5px' : '4px 5px'
            }"
          >
            Average
          </div>
          <div
            *ngIf="showMedian"
            class="data-summary-cell"
            [ngClass]="{ values: showValue && showYoy }"
            [ngStyle]="{
              height: showValue && showYoy ? '44px' : '22px',
              padding: showValue && showYoy ? '12px 5px' : '4px 5px'
            }"
          >
            Median
          </div>
          <div
            *ngIf="showTotal"
            class="data-summary-cell"
            [ngClass]="{ values: showValue && showYoy }"
            [ngStyle]="{
              height: showValue && showYoy ? '44px' : '22px',
              padding: showValue && showYoy ? '12px 5px' : '4px 5px'
            }"
          >
            Total
          </div>
          <div *ngIf="showCompanyCount" style="padding: 4px 5px; height: 22px">
            Companies
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th
        mat-header-cell
        *matHeaderCellDef
        (click)="sortData('company')"
        style="cursor: pointer"
      >
        <span>Company Name</span>
        <span [ngStyle]="{ visibility: dataReady ? 'visible' : 'hidden' }">
          <span
            style="position: absolute; right: 8px; top: 1px; font-size: 16px"
          >
            <va-icon
              size="small"
              isFontAwesome="true"
              [name]="faSortUp"
              [ngStyle]="{
                color:
                  activeSort === 'company' && sortDirection === 'asc'
                    ? '#36abad'
                    : 'lightgray'
              }"
            >
            </va-icon>
          </span>
          <span
            style="position: absolute; right: 8px; top: 5px; font-size: 16px"
          >
            <va-icon
              size="small"
              isFontAwesome="true"
              [name]="faSortDown"
              [ngStyle]="{
                color:
                  activeSort === 'company' && sortDirection === 'desc'
                    ? '#36abad'
                    : 'lightgray'
              }"
            >
            </va-icon>
          </span>
        </span>
      </th>
      <td mat-cell *matCellDef="let element" [title]="element.full_name">
        {{ element.full_name | textEllipsis: 18 }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <div *ngIf="showValue && showYoy">
          <div class="data-summary-cell values" style="height: 44px"></div>
          <div style="padding: 5px; height: 44px"></div>
          <div
            *ngIf="showCompanyCount"
            style="height: 22px; border-top: solid #e8e8e8 1px"
          ></div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="yearend">
      <th
        mat-header-cell
        *matHeaderCellDef
        (click)="sortData('period')"
        style="cursor: pointer"
      >
        <span>FY End</span>
        <span [ngStyle]="{ visibility: dataReady ? 'visible' : 'hidden' }">
          <span
            style="position: absolute; right: 8px; top: 1px; font-size: 16px"
          >
            <va-icon
              size="small"
              isFontAwesome="true"
              [name]="faSortUp"
              [ngStyle]="{
                color:
                  activeSort === 'period' && sortDirection === 'asc'
                    ? '#36abad'
                    : 'lightgray'
              }"
            >
            </va-icon>
          </span>
          <span
            style="position: absolute; right: 8px; top: 5px; font-size: 16px"
          >
            <va-icon
              size="small"
              isFontAwesome="true"
              [name]="faSortDown"
              [ngStyle]="{
                color:
                  activeSort === 'period' && sortDirection === 'desc'
                    ? '#36abad'
                    : 'lightgray'
              }"
            >
            </va-icon>
          </span>
        </span>
      </th>
      <td mat-cell *matCellDef="let element">
        <div *ngIf="!dataReady" style="padding-left: 5px; padding-right: 5px">
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </div>
        <span
          *ngIf="dataReady"
          [innerHtml]="
            compsTableData.rowData[element.ticker] &&
            compsTableData.rowData[element.ticker].relative_period_Y1
              ? compsTableData.rowData[element.ticker].relative_period_Y1
              : '-'
          "
        ></span>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <div *ngIf="showValue && showYoy">
          <div class="data-summary-cell values" style="height: 44px"></div>
          <div style="padding: 5px; height: 44px"></div>
          <div
            *ngIf="showCompanyCount"
            style="height: 22px; border-top: solid #e8e8e8 1px"
          ></div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="datatype">
      <th mat-header-cell *matHeaderCellDef>
        <span>Data</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="data-cell" [ngClass]="{ values: dataReady }">Value</div>
        <div class="data-cell">YoY%</div>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <div class="data-summary-cell" [ngClass]="{ values: dataReady }">
          Value
        </div>
        <div class="data-summary-cell values">YoY%</div>
        <div
          *ngIf="showValue && showYoy"
          class="data-summary-cell"
          [ngClass]="{ values: dataReady }"
        >
          Value
        </div>
        <div class="data-summary-cell">YoY%</div>
        <div
          *ngIf="showCompanyCount && showValue && showYoy"
          class="data-summary-cell"
          style="border-top: solid #e8e8e8 1px"
        >
          Value
        </div>
      </td>
    </ng-container>

    <ng-container
      *ngFor="let item of marketColumns"
      [matColumnDef]="item.id + ''"
    >
      <th
        mat-header-cell
        *matHeaderCellDef
        (click)="sortData(item.id + '')"
        style="cursor: pointer"
        class="line-item-column"
      >
        <div>
          <div style="width: 100px; word-break: break-word">
            {{ item.label }}
          </div>
          <div [ngStyle]="{ visibility: dataReady ? 'visible' : 'hidden' }">
            <span
              style="position: absolute; right: 8px; top: 1px; font-size: 16px"
            >
              <va-icon
                size="small"
                isFontAwesome="true"
                [name]="faSortUp"
                [ngStyle]="{
                  color:
                    activeSort === item.id + '' && sortDirection === 'asc'
                      ? '#36abad'
                      : 'lightgray'
                }"
              >
              </va-icon>
            </span>
            <span
              style="position: absolute; right: 8px; top: 5px; font-size: 16px"
            >
              <va-icon
                size="small"
                isFontAwesome="true"
                [name]="faSortDown"
                [ngStyle]="{
                  color:
                    activeSort === item.id + '' && sortDirection === 'desc'
                      ? '#36abad'
                      : 'lightgray'
                }"
              >
              </va-icon>
            </span>
          </div>
        </div>
      </th>
      <td mat-cell *matCellDef="let element" class="line-item-cell">
        <div *ngIf="!dataReady" style="padding-left: 5px; padding-right: 5px">
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </div>
        <div
          *ngIf="dataReady && showValue"
          class="data-cell"
          (click)="
            onMarketLineCellClick(element.ticker, item.id, 'values', $event)
          "
          (contextmenu)="cellContextMenu($event, element, item.id, 'values')"
          [ngClass]="{
            'selected-line-cell':
              selectedLineCell == element.ticker + '_values_' + item.id,
            values: showValue && showYoy,
            'negative-value':
              compsTableData.rowData[element.ticker] &&
              compsTableData.rowData[element.ticker].market_data &&
              compsTableData.rowData[element.ticker].market_data[item.id] &&
              compsTableData.rowData[element.ticker].market_data[item.id]
                .values < 0
          }"
        >
          <ng-container
            *ngIf="
              compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker].market_data &&
                compsTableData.rowData[element.ticker].market_data[item.id] &&
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .formattedValue;
              else emptyData
            "
          >
            <span nz-tooltip [nzTooltipTitle]="marketTooltip">
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .formattedValue
              }}
            </span>
          </ng-container>
          <ng-template #emptyData>
            <span> - </span>
          </ng-template>
          <ng-template #marketTooltip>
            <div class="ca-tooltip-content">
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .formattedValue
              }}
              <br />
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .lastDate
              }}
              <br />
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .exchangeFullName
              }}
            </div>
          </ng-template>
        </div>
        <div
          *ngIf="dataReady && showYoy"
          class="data-cell"
          (click)="
            onMarketLineCellClick(element.ticker, item.id, 'yoy', $event)
          "
          (contextmenu)="cellContextMenu($event, element, item.id, 'yoy')"
          [ngClass]="{
            'selected-line-cell':
              selectedLineCell == element.ticker + '_yoy_' + item.id,
            'negative-value':
              compsTableData.rowData[element.ticker] &&
              compsTableData.rowData[element.ticker].market_data &&
              compsTableData.rowData[element.ticker].market_data[item.id] &&
              compsTableData.rowData[element.ticker].market_data[item.id].yoy <
                0
          }"
        >
          <ng-container
            *ngIf="
              compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker].market_data &&
                compsTableData.rowData[element.ticker].market_data[item.id] &&
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .formattedYoy;
              else emptyData
            "
          >
            <span nz-tooltip [nzTooltipTitle]="marketTooltip">
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .formattedYoy
              }}
            </span>
          </ng-container>
          <ng-template #emptyData>
            <span> - </span>
          </ng-template>
          <ng-template #marketTooltip>
            <div class="ca-tooltip-content">
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .formattedYoy
              }}
              <br />
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .lastDate
              }}
              <br />
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .exchangeFullName
              }}
            </div>
          </ng-template>
        </div>
        <div
          *ngIf="dataReady && showRevision"
          class="data-cell"
          (click)="
            onMarketLineCellClick(element.ticker, item.id, 'revision', $event)
          "
          (contextmenu)="cellContextMenu($event, element, item.id, 'revision')"
          [ngClass]="{
            'selected-line-cell':
              selectedLineCell == element.ticker + '_revision_' + item.id,
            values: showValue && showYoy,
            'negative-value':
              compsTableData.rowData[element.ticker] &&
              compsTableData.rowData[element.ticker].market_data &&
              compsTableData.rowData[element.ticker].market_data[item.id] &&
              compsTableData.rowData[element.ticker].market_data[item.id]
                .revision < 0
          }"
        >
          <ng-container
            *ngIf="
              compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker].market_data &&
                compsTableData.rowData[element.ticker].market_data[item.id] &&
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .formattedRevision;
              else emptyData
            "
          >
            <span nz-tooltip [nzTooltipTitle]="marketTooltip">
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .formattedRevision
              }}
            </span>
          </ng-container>
          <ng-template #emptyData>
            <span> - </span>
          </ng-template>
          <ng-template #marketTooltip>
            <div class="ca-tooltip-content">
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .formattedRevision
              }}
              <br />
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .lastDate
              }}
              <br />
              {{
                compsTableData.rowData[element.ticker].market_data[item.id]
                  .exchangeFullName
              }}
            </div>
          </ng-template>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef class="line-item-cell">
        <div *ngIf="!dataReady" style="padding-left: 5px; padding-right: 5px">
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </div>
        <div
          *ngIf="!dataReady && showValue && showYoy"
          style="padding-left: 5px; padding-right: 5px"
        >
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </div>
        <div class="average-summary" *ngIf="showAverage">
          <div
            *ngIf="dataReady && showValue"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].average &&
                compsTableData.columnData[item.id].average.values < 0,
              values: dataReady && showValue && showYoy
            }"
          >
            <span *ngIf="item.id !== 10">
              {{
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].average.formattedValue
                  ? compsTableData.columnData[item.id].average.formattedValue
                  : "-"
              }}
            </span>
          </div>
          <div
            *ngIf="dataReady && showYoy"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].average &&
                compsTableData.columnData[item.id].average.yoy < 0,
              values: dataReady && showValue && showYoy
            }"
          >
            <span *ngIf="item.id !== 10">
              {{
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].average.formattedYoy
                  ? compsTableData.columnData[item.id].average.formattedYoy
                  : "-"
              }}
            </span>
          </div>
          <div
            *ngIf="dataReady && showRevision"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].average &&
                compsTableData.columnData[item.id].average.revision < 0,
              values: dataReady && showValue && showYoy
            }"
          >
            <span *ngIf="item.id !== 10">
              {{
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].average.formattedRevision
                  ? compsTableData.columnData[item.id].average.formattedRevision
                  : "-"
              }}
            </span>
          </div>
        </div>
        <div class="median-summary" *ngIf="showMedian">
          <div
            *ngIf="dataReady && showValue"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].median &&
                compsTableData.columnData[item.id].median.values < 0,
              values: dataReady && showValue && showYoy
            }"
          >
            <span *ngIf="item.id !== 10">
              {{
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].median.formattedValue
                  ? compsTableData.columnData[item.id].median.formattedValue
                  : "-"
              }}
            </span>
          </div>
          <div
            *ngIf="dataReady && showYoy"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].median &&
                compsTableData.columnData[item.id].median.yoy < 0
            }"
          >
            <span *ngIf="item.id !== 10">
              {{
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].median.formattedYoy
                  ? compsTableData.columnData[item.id].median.formattedYoy
                  : "-"
              }}
            </span>
          </div>
          <div
            *ngIf="dataReady && showRevision"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].median &&
                compsTableData.columnData[item.id].median.revision < 0
            }"
          >
            <span *ngIf="item.id !== 10">
              {{
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].median.formattedRevision
                  ? compsTableData.columnData[item.id].median.formattedRevision
                  : "-"
              }}
            </span>
          </div>
        </div>
        <div class="total-summary" *ngIf="showTotal">
          <div
            *ngIf="dataReady && showValue"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].total &&
                compsTableData.columnData[item.id].total.values < 0,
              values: dataReady && showValue && showYoy
            }"
          >
            <span *ngIf="item.id !== 10">
              {{
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].total.formattedValue
                  ? compsTableData.columnData[item.id].total.formattedValue
                  : "-"
              }}
            </span>
          </div>
          <div
            *ngIf="dataReady && showYoy"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].total &&
                compsTableData.columnData[item.id].total.yoy < 0
            }"
          >
            <span *ngIf="item.id !== 10">
              {{
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].total.formattedYoy
                  ? compsTableData.columnData[item.id].total.formattedYoy
                  : "-"
              }}
            </span>
          </div>
          <div
            *ngIf="dataReady && showRevision"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].total &&
                compsTableData.columnData[item.id].total.revision < 0
            }"
          >
            <span *ngIf="item.id !== 10">
              {{
                compsTableData.columnData[item.id] &&
                compsTableData.columnData[item.id].total.formattedRevision
                  ? compsTableData.columnData[item.id].total.formattedRevision
                  : "-"
              }}
            </span>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container
      *ngFor="
        let colKey of displayColumns.slice(
          (showValue && showYoy ? 4 : 3) + marketColumns.length
        );
        let i = index
      "
      [matColumnDef]="colKey + ''"
    >
      <th
        mat-header-cell
        *matHeaderCellDef
        class="line-item-column"
        [ngStyle]="{
          'font-style': compsTableData.columnData[colKey].isFuzzy
            ? 'italic'
            : 'normal'
        }"
        (click)="sortData(colKey + '')"
        style="cursor: pointer"
      >
        <div
          style="width: 100px; word-break: break-word"
          [ngClass]="{
            'fuzzy-cell':
              !isTimeSeries &&
              compsTableData.columnData[colKey].isFuzzy &&
              fuzzySwitch
          }"
          [title]="compsTableData.columnData[colKey].colDisplayName"
        >
          {{
            compsTableData.columnData[colKey].colDisplayName | textEllipsis: 40
          }}
        </div>
        <div [ngStyle]="{ visibility: dataReady ? 'visible' : 'hidden' }">
          <span
            style="position: absolute; right: 8px; top: 1px; font-size: 16px"
          >
            <va-icon
              size="small"
              isFontAwesome="true"
              [name]="faSortUp"
              [ngStyle]="{
                color:
                  activeSort === colKey + '' && sortDirection === 'asc'
                    ? '#36abad'
                    : 'lightgray'
              }"
            >
            </va-icon>
          </span>
          <span
            style="position: absolute; right: 8px; top: 5px; font-size: 16px"
          >
            <va-icon
              size="small"
              isFontAwesome="true"
              [name]="faSortDown"
              [ngStyle]="{
                color:
                  activeSort === colKey + '' && sortDirection === 'desc'
                    ? '#36abad'
                    : 'lightgray'
              }"
            >
            </va-icon>
          </span>
        </div>
      </th>
      <td mat-cell *matCellDef="let element" class="line-item-cell">
        <div *ngIf="!dataReady" style="padding-left: 5px; padding-right: 5px">
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </div>
        <div
          *ngIf="dataReady && showValue"
          class="data-cell"
          [ngClass]="{
            'selected-line-cell':
              selectedLineCell == element.ticker + '_values_' + colKey,
            values: showValue && showYoy,
            'negative-value': isTimeSeries
              ? compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey].values < 0
              : compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][colKey] &&
                compsTableData.rowData[element.ticker][colKey][
                  selectedPeriod
                ] &&
                compsTableData.rowData[element.ticker][colKey][selectedPeriod]
                  .values < 0,
            'fuzzy-cell': isTimeSeries
              ? compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId + '|FZY'
                ] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey] &&
                fuzzySwitch
              : compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][colKey + '|FZY'] &&
                compsTableData.rowData[element.ticker][colKey][
                  selectedPeriod
                ] &&
                fuzzySwitch
          }"
          [ngStyle]="{
            'font-style': isTimeSeries
              ? compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId + '|FZY'
                ] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey]
                ? 'italic'
                : 'normal'
              : compsTableData.rowData[element.ticker] &&
                  compsTableData.rowData[element.ticker][colKey + '|FZY'] &&
                  compsTableData.rowData[element.ticker][colKey][selectedPeriod]
                ? 'italic'
                : 'normal'
          }"
          (click)="onLineCellClick(element.ticker, colKey, 'values', $event)"
          (contextmenu)="cellContextMenu($event, element, colKey, 'values')"
          [innerHtml]="
            isTimeSeries
              ? compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey].formattedValue
                ? compsTableData.rowData[element.ticker][
                    compsTableData.columnData[colKey].sliCompsId
                  ][colKey].formattedValue
                : '-'
              : compsTableData.rowData[element.ticker] &&
                  compsTableData.rowData[element.ticker][colKey] &&
                  compsTableData.rowData[element.ticker][colKey][
                    selectedPeriod
                  ] &&
                  compsTableData.rowData[element.ticker][colKey][selectedPeriod]
                    .formattedValue
                ? compsTableData.rowData[element.ticker][colKey][selectedPeriod]
                    .formattedValue
                : '-'
          "
        ></div>
        <div
          *ngIf="dataReady && showYoy"
          class="data-cell"
          [ngClass]="{
            'selected-line-cell':
              selectedLineCell == element.ticker + '_yoy_' + colKey,
            'negative-value': isTimeSeries
              ? compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey].yoy < 0
              : compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][colKey] &&
                compsTableData.rowData[element.ticker][colKey][
                  selectedPeriod
                ] &&
                compsTableData.rowData[element.ticker][colKey][selectedPeriod]
                  .yoy < 0,
            'fuzzy-cell': isTimeSeries
              ? compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId + '|FZY'
                ] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey] &&
                fuzzySwitch
              : compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][colKey + '|FZY'] &&
                compsTableData.rowData[element.ticker][colKey][
                  selectedPeriod
                ] &&
                fuzzySwitch
          }"
          [ngStyle]="{
            'font-style': 'italic'
          }"
          (click)="onLineCellClick(element.ticker, colKey, 'yoy', $event)"
          (contextmenu)="cellContextMenu($event, element, colKey, 'yoy')"
          [innerHtml]="
            isTimeSeries
              ? compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey].formattedYoy
                ? compsTableData.rowData[element.ticker][
                    compsTableData.columnData[colKey].sliCompsId
                  ][colKey].formattedYoy
                : '-'
              : compsTableData.rowData[element.ticker] &&
                  compsTableData.rowData[element.ticker][colKey] &&
                  compsTableData.rowData[element.ticker][colKey][
                    selectedPeriod
                  ] &&
                  compsTableData.rowData[element.ticker][colKey][selectedPeriod]
                    .formattedYoy
                ? compsTableData.rowData[element.ticker][colKey][selectedPeriod]
                    .formattedYoy
                : '-'
          "
        ></div>
        <div
          *ngIf="dataReady && showRevision"
          class="data-cell"
          [ngClass]="{
            'selected-line-cell':
              selectedLineCell == element.ticker + '_revision_' + colKey,
            'negative-value': isTimeSeries
              ? compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey].revision < 0
              : compsTableData.rowData[element.ticker][colKey] &&
                compsTableData.rowData[element.ticker][colKey][
                  selectedPeriod
                ] &&
                compsTableData.rowData[element.ticker][colKey][selectedPeriod]
                  .revision < 0,
            'fuzzy-cell': isTimeSeries
              ? compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId + '|FZY'
                ] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey] &&
                fuzzySwitch
              : compsTableData.rowData[element.ticker][colKey + '|FZY'] &&
                compsTableData.rowData[element.ticker][colKey][
                  selectedPeriod
                ] &&
                fuzzySwitch
          }"
          [ngStyle]="{
            'font-style': isTimeSeries
              ? compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId + '|FZY'
                ] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey]
                ? 'italic'
                : 'normal'
              : compsTableData.rowData[element.ticker] &&
                  compsTableData.rowData[element.ticker][colKey + '|FZY'] &&
                  compsTableData.rowData[element.ticker][colKey][selectedPeriod]
                ? 'italic'
                : 'normal'
          }"
          (click)="onLineCellClick(element.ticker, colKey, 'revision', $event)"
          (contextmenu)="cellContextMenu($event, element, colKey, 'revision')"
          [innerHtml]="
            isTimeSeries
              ? compsTableData.rowData[element.ticker] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey] &&
                compsTableData.rowData[element.ticker][
                  compsTableData.columnData[colKey].sliCompsId
                ][colKey].formattedRev
                ? compsTableData.rowData[element.ticker][
                    compsTableData.columnData[colKey].sliCompsId
                  ][colKey].formattedRev
                : '-'
              : compsTableData.rowData[element.ticker] &&
                  compsTableData.rowData[element.ticker][colKey] &&
                  compsTableData.rowData[element.ticker][colKey][
                    selectedPeriod
                  ] &&
                  compsTableData.rowData[element.ticker][colKey][selectedPeriod]
                    .formattedRev
                ? compsTableData.rowData[element.ticker][colKey][selectedPeriod]
                    .formattedRev
                : '-'
          "
        ></div>
      </td>
      <td mat-footer-cell *matFooterCellDef class="line-item-cell">
        <div *ngIf="!dataReady" style="padding-left: 5px; padding-right: 5px">
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </div>
        <div
          *ngIf="!dataReady && showValue && showYoy"
          style="padding-left: 5px; padding-right: 5px"
        >
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </div>
        <div class="average-summary" *ngIf="showAverage">
          <div
            *ngIf="dataReady && showValue"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[colKey].average.values &&
                compsTableData.columnData[colKey].average.values < 0,
              values: dataReady && showValue && showYoy
            }"
            [innerHtml]="
              formatCell(
                compsTableData.columnData[colKey].average.values,
                compsTableData.columnData[colKey].average.currency,
                colKey,
                'values'
              )
            "
          ></div>
          <div
            *ngIf="dataReady && showYoy"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[colKey].average.yoy &&
                compsTableData.columnData[colKey].average.yoy < 0,
              values: dataReady && showValue && showYoy
            }"
            [ngStyle]="{
              'font-style': 'italic'
            }"
            [innerHtml]="
              formatCell(
                compsTableData.columnData[colKey].average.yoy,
                compsTableData.columnData[colKey].average.currency,
                colKey,
                'yoy'
              )
            "
          ></div>
          <div
            *ngIf="dataReady && showRevision"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[colKey].average.revision &&
                compsTableData.columnData[colKey].average.revision < 0,
              values: dataReady && showValue && showYoy
            }"
            [innerHtml]="
              formatCell(
                compsTableData.columnData[colKey].average.revision,
                compsTableData.columnData[colKey].average.currency,
                colKey,
                'revision'
              )
            "
          ></div>
        </div>
        <div class="median-summary" *ngIf="showMedian">
          <div
            *ngIf="dataReady && showValue"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[colKey].median.values &&
                compsTableData.columnData[colKey].median.values < 0,
              values: dataReady && showValue && showYoy
            }"
            [innerHtml]="
              formatCell(
                compsTableData.columnData[colKey].median.values,
                compsTableData.columnData[colKey].median.currency,
                colKey,
                'values'
              )
            "
          ></div>
          <div
            *ngIf="dataReady && showYoy"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[colKey].median.yoy &&
                compsTableData.columnData[colKey].median.yoy < 0,
              values: dataReady && showValue && showYoy
            }"
            [ngStyle]="{
              'font-style': 'italic'
            }"
            [innerHtml]="
              formatCell(
                compsTableData.columnData[colKey].median.yoy,
                compsTableData.columnData[colKey].median.currency,
                colKey,
                'yoy'
              )
            "
          ></div>
          <div
            *ngIf="dataReady && showRevision"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[colKey].median.revision &&
                compsTableData.columnData[colKey].median.revision < 0,
              values: dataReady && showValue && showYoy
            }"
            [innerHtml]="
              formatCell(
                compsTableData.columnData[colKey].median.revision,
                compsTableData.columnData[colKey].median.currency,
                colKey,
                'revision'
              )
            "
          ></div>
        </div>
        <div class="total-summary" *ngIf="showTotal">
          <div
            *ngIf="dataReady && showValue"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[colKey].total.values &&
                compsTableData.columnData[colKey].total.values < 0,
              values: dataReady && showValue && showYoy
            }"
            [innerHtml]="
              formatCell(
                compsTableData.columnData[colKey].total.values,
                compsTableData.columnData[colKey].total.currency,
                colKey,
                'values'
              )
            "
          ></div>
          <div
            *ngIf="dataReady && showYoy"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[colKey].total.yoy &&
                compsTableData.columnData[colKey].total.yoy < 0,
              values: dataReady && showValue && showYoy
            }"
            [ngStyle]="{
              'font-style': 'italic'
            }"
            [innerHtml]="
              formatCell(
                compsTableData.columnData[colKey].total.yoy,
                compsTableData.columnData[colKey].total.currency,
                colKey,
                'yoy'
              )
            "
          ></div>
          <div
            *ngIf="dataReady && showRevision"
            class="data-summary-cell"
            [ngClass]="{
              'negative-value':
                compsTableData.columnData[colKey].total.revision &&
                compsTableData.columnData[colKey].total.revision < 0,
              values: dataReady && showValue && showYoy
            }"
            [innerHtml]="
              formatCell(
                compsTableData.columnData[colKey].total.revision,
                compsTableData.columnData[colKey].total.currency,
                colKey,
                'revision'
              )
            "
          ></div>
        </div>
        <div class="company-total-summary" *ngIf="showCompanyCount">
          <div
            *ngIf="dataReady && showValue"
            class="data-summary-cell"
            [ngClass]="{
              values: dataReady && showValue && showYoy
            }"
          >
            <span>
              {{
                compsTableData.columnData[colKey] &&
                compsTableData.columnData[colKey].tickerCount.values !==
                  undefined
                  ? compsTableData.columnData[colKey].tickerCount.values
                  : "-"
              }}
            </span>
          </div>
          <div
            *ngIf="dataReady && showYoy && !showValue"
            class="data-summary-cell"
            [ngClass]="{
              values: dataReady && showValue && showYoy
            }"
          >
            <span>
              {{
                compsTableData.columnData[colKey] &&
                compsTableData.columnData[colKey].tickerCount.yoy !== undefined
                  ? compsTableData.columnData[colKey].tickerCount.yoy
                  : "-"
              }}
            </span>
          </div>
          <div
            *ngIf="dataReady && showRevision"
            class="data-summary-cell"
            [ngClass]="{
              values: dataReady && showValue && showYoy
            }"
          >
            {{
              compsTableData.columnData[colKey] &&
              compsTableData.columnData[colKey].tickerCount.revision !==
                undefined
                ? compsTableData.columnData[colKey].tickerCount.revision
                : "-"
            }}
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayColumns"
      [ngClass]="{ 'selected-ticker': selectedTicker == row.ticker }"
      (click)="onRowClick(row)"
    ></tr>
    <tr
      mat-footer-row
      *matFooterRowDef="displayColumns; sticky: true"
      class="footer-row"
    ></tr>
  </table>
</div>

<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon
      size="small"
      name="check"
      class="snack-icon snack-success-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
